import React, { useRef } from 'react';
import './CtaButton.scss';
import contents from '../../contents';
import ctaButtonImg from '../../Assets/ctaButtonImg.jpg';
import ctaButtonArrow from '../../Assets/ctaButtonArrow.svg';

function CtaButton({ handleMouseLeaveTooltip, handleMouseEnterTooltip }) {
  const ctaTooltip = useRef();
  return (
    <>
      <a href={contents.ctaTooltip.href} target="_blank" rel="sponsored noopener" className="cta">
        <button
          className="cta__button"
          onMouseEnter={(e) => {
            handleMouseEnterTooltip(e, ctaTooltip);
          }}
          onMouseLeave={() => {
            handleMouseLeaveTooltip(ctaTooltip);
          }}
        >
          <img src={ctaButtonImg} alt="girls" />
          To find out more or to get involved in The N50 Project, please visit www.N50project.org.
          <img src={ctaButtonArrow} alt="triangle" />
        </button>
      </a>
      <div className="tooltip" ref={ctaTooltip}>
        <p className="tooltip__content">{contents.ctaTooltip.copy}</p>
      </div>
    </>
  );
}

export default CtaButton;
